import { type CSSProperties, useState } from 'react';

import useInterval from '../../utils/useInterval';

import type { LeafAnimation } from '../../types';
import { AnimatedTextScroll } from './AnimatedTextScroll';

export function AnimatedText({
  animation,
  style,
}: {
  animation: LeafAnimation | undefined;
  style: CSSProperties | undefined;
}) {
  const type = animation?.type;
  const words = animation?.words ?? [];

  const [currIdx, setcurrIdx] = useState(0);

  useInterval(
    () => {
      setcurrIdx((currIdx + 1) % (words.length || 1));
    },
    type === 'scroll_words' && words.length > 1 ? 2500 : 0,
  );

  if (!animation || words.length === 0) return null;

  if (type === 'scroll_words' && words.length > 1) {
    return <AnimatedTextScroll words={words} currIdx={currIdx} style={style} />;
  }

  return <>{words[0]}</>;
}
